export default {
    LOAD_PROPOSAL_TEMPLATE(state, proposal_template) {
        state.items = proposal_template;
    }
}